import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState, } from "react";
import { connectModalStore } from "@layerswap/wallet-core";
const ConnectModalContext = createContext(null);
export function WalletModalProvider({ children }) {
    const [selectedProvider, setSelectedProvider] = useState();
    const [selectedConnector, setSelectedConnector] = useState();
    const [selectedMultiChainConnector, setSelectedMultiChainConnector] = useState();
    const [resolveConnection, setResolveConnection] = useState();
    const start = useCallback((provider) => new Promise(resolve => {
        setSelectedProvider(provider);
        setResolveConnection(() => resolve);
    }), []);
    const resolve = useCallback((wallet) => {
        setResolveConnection(current => {
            current?.(wallet);
            return undefined;
        });
        setSelectedConnector(undefined);
        setSelectedMultiChainConnector(undefined);
        setSelectedProvider(undefined);
    }, []);
    const cancel = useCallback(() => resolve(undefined), [resolve]);
    const finish = useCallback((wallet) => resolve(wallet), [resolve]);
    const goBack = useCallback(() => {
        if (selectedConnector) {
            setSelectedConnector(undefined);
            setSelectedMultiChainConnector(undefined);
            return;
        }
        if (selectedMultiChainConnector)
            setSelectedMultiChainConnector(undefined);
    }, [selectedConnector, selectedMultiChainConnector]);
    useEffect(() => {
        connectModalStore._syncSelectedConnector(selectedConnector);
    }, [selectedConnector]);
    useEffect(() => connectModalStore._registerWriter(connector => {
        setSelectedConnector(connector);
    }), []);
    const value = useMemo(() => ({
        selectedProvider,
        setSelectedProvider,
        selectedConnector,
        setSelectedConnector,
        selectedMultiChainConnector,
        setSelectedMultiChainConnector,
        start,
        cancel,
        finish,
        goBack,
    }), [cancel, finish, goBack, selectedConnector, selectedMultiChainConnector, selectedProvider, start]);
    return _jsx(ConnectModalContext.Provider, { value: value, children: children });
}
export function useConnectModal() {
    const context = useContext(ConnectModalContext);
    if (!context)
        throw new Error("useConnectModal must be used within WalletModalProvider");
    return context;
}
